module.exports = __webpack_public_path__ + "static/assets/0b8b6b69c311fff2fba742b6c323fbe6.png";